// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_Yrphv","modal-wrap":"modal-wrap_fQvtL","close-icon":"close-icon_dTHMi","content-wrap":"content-wrap_idVKJ"};